import { render } from "./Avatar.ce.vue?vue&type=template&id=3c002d14"
import script from "./Avatar.ce.vue?vue&type=script&lang=js"
export * from "./Avatar.ce.vue?vue&type=script&lang=js"

import _style_0 from "./Avatar.ce.vue?vue&type=style&index=0&id=3c002d14&inline&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__